import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { useObrasGestaoResiduosViewModel } from "../../viewModels/obras_gestaoresiduos_view_model";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GenerateControleColumnDefinition } from "./columns";
import { GetAllObrasGestaoDeResiduosData } from "../../../data/daos/read/get_all_obras_gestao_de_residuos";
import { ModalCreateGestaoResiduos } from "./components/modal_create";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { ObrasReportModals } from "../../components/obras_report_modals";

import DeleteDialog from "../../../../../common/components/delete_dialog";

export const ObrasGestaoResiduos = () => {
  const viewModel = useObrasGestaoResiduosViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateControleColumnDefinition({
      onActionEditar: viewModel.handleEditMaquinasEquipamentoOpenState,
      onActionDeletar: viewModel.DeleteOpenModal,
      onActionDownload: viewModel.handleDownload,
    });
  }, [
    viewModel.handleEditMaquinasEquipamentoOpenState,
    viewModel.DeleteOpenModal,
    viewModel.handleDownload,
  ]);

  return (
    <>
      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObra ?? null}
        onBack={viewModel.handleBack}
      ></ObrasTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Link href="/Obras_lista" underline="hover" color="inherit">
            Lista de Obras
          </Link>
          <Typography className="text-primary-green">Gestão de Resíduos</Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <ObrasTopHeader
            title="Gestão de Resíduos"
            selectedObra={viewModel.selectedObra ?? null}
            onReload={viewModel.load}
            onNewItem={viewModel.abrirModalCreate}
          />
          {/* <div className="w-full justify-end flex gap-2">
              <div className="w-[130px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.abrirModalCreate()}
                >
                  Novo item
                </PrimaryButton>
              </div>

              <BackButton onClick={viewModel.handleBack} />
            </div> */}
        </div>
        <Stack spacing={0}>
          <div className="w-full flex flex-row justify-between items-stretch">
            <div className="flex flex-col flex-wrap justify-end">
              <LegendComponent></LegendComponent>
            </div>

            <div className="flex flex-col justify-between flex-1">
              <TablePagination
                component="div"
                count={viewModel.pagination.totalItems}
                page={viewModel.pagination.page - 1}
                onPageChange={(_, p) => viewModel.handlePageChange(p)}
                rowsPerPageOptions={[10, 25, 50, 100]}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
              />
            </div>
          </div>

          <StyledDataGrid
            tableName="Obrasmaquinasequipamentos"
            disableColumnMenu={false}
            showToolbar={true}
            disableRowSelectionOnClick={true}
            getRowId={(row: GetAllObrasGestaoDeResiduosData) => row.idGestaoResiduos ?? ""}
            getRowHeight={() => 'auto'}
            columns={columnsDefinition}
            loading={viewModel.loading}
            checkboxSelection={false}
            rows={viewModel.Obrasgestaoresiduos}
            rowCount={viewModel.Obrasgestaoresiduos.length}
            pageSizeOptions={[10, 25, 50, 100]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }}
            pinnedColumns={{
              right: ["idManutencaoEquipObra"],
            }}
          />

          <div className="flex flex-col justify-between flex-1">
            <TablePagination
              component="div"
              count={viewModel.pagination.totalItems}
              page={viewModel.pagination.page - 1}
              onPageChange={(_, p) => viewModel.handlePageChange(p)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={viewModel.pagination.rowsPerPage}
              onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
            />
          </div>
        </Stack>
      </div>
      <ModalCreateGestaoResiduos
        open={viewModel.abrirModal}
        saving={viewModel.saving}
        onClose={() => viewModel.fecharmodal()}
        onSubmit={viewModel.handleDocumentoSubmit}
        dados={viewModel.dadosEdit}
        editmod={viewModel.editmod}
      />

      <ObrasReportModals
        state={viewModel.obrasReportState}
      />

      <DeleteDialog
        open={viewModel.openDeleteModal}
        onClose={() => viewModel.DeleteOpenModal(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.DeletarGestaoResiduos}
      />
    </>
  );
};
